import React from 'react';
import {Form, Input, Select, Col, Row, InputNumber, message, DatePicker, Radio, Tree} from 'antd';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {
    dicClrgRuleType,
     commonIsMap, dicExecutionSequenceType, dicExecutionCycle
} from '../../../../axios/dictionaries';
import moment from 'moment';
import DetailTitle from "../../../../components/DetailTitle";
import {
    API_Merchant_findHsbPayChannelConfigAll,
    API_Merchant_getHsbAccountingRulesList,
    API_Merchant_getHsbMerchantInfoList,
} from "../../../../axios/config";
import {formatTime} from "../../../../utils";

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "编辑分账规则",
            radioLessReliefTypeValue:false,
            clrgRuleList: [], // 分账规则编号 下拉
            hsbPayChannelList:[],//惠市宝支付渠道
            hsbMerchantList:[], // 商户编号 下拉
            merchantData: [],
            buildingData: [],
            selectUpperLimitValue: false,
            checkedKeys: [], //选中的房源
            data: {
                houseLayout: [],
            },
        }
    }

    pullHouseMessage = (merchantId,jh) => { //拉取房源信息

        this.setState({ loading: true });
        postFrom({
            url: config.API_building_findBuildingList, data: {
                merchantId
            }
        }).then(res => {
            this.setState({ buildingData: res, loading: false }, () => {
                for (let i = 0; i < res.length; i++) {
                    this.handleGetFloor(res[i].id)
                }
            });
        }).catch(err => {
            message.error(err.message || '获取房源（小区/楼栋）列表失败');
            this.setState({ loading: false });
        });
    }

    postClrgRuleList() {
        post({ url: API_Merchant_getHsbAccountingRulesList }).then(res => {
            this.setState({ clrgRuleList: res })
        })
    }

    postHsbMerchantInfoList() {
        post({ url: API_Merchant_getHsbMerchantInfoList }).then(res => {
            this.setState({ hsbMerchantList: res })
        })
    }

    handleGetFloor = (buildingId) => {
        postFrom({ url: config.API_hsbPayChannel_findBuildingHouseList, data: { buildingId } }).then(res => {
            let { data: { projectHouses }, checkedKeys, buildingData } = this.state;
            let existing = []; //存放当前项目关联的房源
            if (projectHouses instanceof Array) {
                existing = projectHouses.filter(item => +item.buildingId === buildingId);
            }
            let arr = [].concat(existing, res); //连接被关联的房源与未被关联的房源
            arr.sort((a, b) => a.floor - b.floor); //针对楼层排序
            let floor = [];
            arr.forEach(el => { //生成出分楼层房号的数组
                let value = floor.find(item => item.name === `楼层：${el.floor}`);
                if (value) {
                    value.children.push({ name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true })
                } else {
                    floor.push({
                        name: `楼层：${el.floor}`,
                        id: `${el.houseId}·${el.floor}`,
                        children: [
                            { name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true }
                        ]
                    })
                }
            });
            floor.forEach((el => { //针对房号排序
                el.children.sort((a, b) => a.name.slice(3) - b.name.slice(3));
            }));
            let nowBuilding = buildingData.find(item => item.id === buildingId);
            nowBuilding ? nowBuilding.children = floor : null;
            for (let i = 0; i < existing.length; i++) { //加入已被关联房源的选中
                if (checkedKeys.indexOf(`houseId${existing[i].houseId}`) === -1) {
                    checkedKeys.push(`houseId${existing[i].houseId}`);
                }
            }
            this.setState({ buildingData, checkedKeys });
        }).catch(err => {
            message.error(err.message || '获取未关联房源列表失败');
        });
    }

    handleLessReliefTypeChange = (e) => { // 最低减免类型
        const radioLessReliefTypeValue = e.target.value
        this.setState({
            radioLessReliefTypeValue
        })
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            merchantData,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="支付渠道">
                                    {getFieldDecorator('hsbPayChannelConfigId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.hsbPayChannelConfigId
                                    })(
                                        <Select   placeholder="请选择支付渠道"  showSearch  optionFilterProp={'children'}>
                                            {this.state.hsbPayChannelList.map(e => (
                                                <Select.Option key={e.id} value={e.id}>{e.projectName}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="分账规则编号">
                                    {getFieldDecorator('clrgRuleId', {
                                        rules: [{
                                            message: '请输入',required: true,
                                        }],
                                        initialValue:  data.clrgRuleId
                                    })(
                                        <Select  placeholder="请选择分账规则编号"  showSearch  optionFilterProp={'children'}   onChange={(e) => this.handleFormChange({clrgRuleId: e})} >
                                            {this.state.clrgRuleList.map(e => (
                                                <Select.Option key={e.clrgRuleId} value={e.clrgRuleId} >{e.ruleNm}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="费用类型">
                                    {getFieldDecorator('clrgRuleType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.clrgRuleType
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择费用类型"
                                            optionFilterProp={'children'}
                                        >
                                            {dicClrgRuleType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="应汇集金额">
                                    {getFieldDecorator('totalMoney', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.totalMoney
                                    })(
                                        <InputNumber
                                            placeholder={'请输入应汇集金额'}
                                            autoComplete={'off'}
                                            min ={0}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="执行顺序">
                                    {getFieldDecorator('executionSequence', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionSequence
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行顺序"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionSequenceType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="执行周期">
                                    {getFieldDecorator('executionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="周期开始日期">
                                    {getFieldDecorator("startDate", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "请选择开始日期",
                                            },
                                        ],
                                        initialValue: data.startDate?moment(data.startDate):null
                                    })(<DatePicker placeholder="开始日期" />)}
                                </CustomCol>
                                <CustomCol  label="周期结束日期">
                                    {getFieldDecorator("endDate", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "请选择结束日期",
                                            },
                                        ],
                                        initialValue:  data.endDate?moment(data.endDate):null
                                    })(<DatePicker placeholder="结束日期" />)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="汇集截止日期" required={false}>
                                    {getFieldDecorator("collectionEndDate", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "请选择汇集截止日期",
                                            },
                                        ],
                                        initialValue:  data.collectionEndDate?moment(data.collectionEndDate):null
                                    })(<DatePicker placeholder="截止日期" />)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="允许超出上限">
                                    {getFieldDecorator('upperLimit', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.upperLimit || 2
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={this.handleUpperLimitChange}
                                        >
                                            {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}

                                </CustomCol>
                                {this.state.selectUpperLimitValue?
                                    <CustomCol label="上限金额">
                                        {getFieldDecorator('upperLimitMoney', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.upperLimitMoney
                                        })(
                                            <InputNumber
                                                placeholder={'请输入上限金额'}
                                                autoComplete={'off'}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>:null
                                }
                            </CustomRow>

                            <DetailTitle title="分账规则参与方配置" />
                            {
                                data.rulesMemberListList instanceof Array
                                    ? data.rulesMemberListList.map((item, index) => {
                                        return item.rulesMemberListList  ? null: <CustomRow key={item.key} divider>
                                            <CustomCol label="顺序号">
                                                {getFieldDecorator(`splitAccountA${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.splitAccountA
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        disabled={true}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol label="分账商家编号">
                                                {getFieldDecorator(`splitAccountE${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.splitAccountE
                                                })(
                                                    <Select>
                                                        {this.state.hsbMerchantList.map(e => (
                                                            <Select.Option key={e.mktMrchId} value={e.mktMrchId}>{e.mktMrchNm}</Select.Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </CustomCol>
                                        </CustomRow>
                                    })
                                    : null

                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }


    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "新增支付渠道",buildingData: [], checkedKeys: [],selectUpperLimitValue:false });
    }

    initPack = () => {
        this.forceUpdate();
        this.postHsbPayChannelConfigAll();
        this.postClrgRuleList();
        this.postHsbMerchantInfoList();

    }

    handleUpperLimitChange = (e) => { // 是否开启建行

        const selectUpperLimitValue = e===1?true:false
        this.setState({
            selectUpperLimitValue
        })
    }

    handleFormChange = (data) => {
        if (!data.clrgRuleId) {
            this.state.data.rulesMemberListList=[];
        } else {
            console.log(data);

            let rulesMemberListList = this.state.clrgRuleList.filter(obj => obj.clrgRuleId === data.clrgRuleId)[0].rulesMemberListList;

            console.log(rulesMemberListList);

            rulesMemberListList = rulesMemberListList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                item = {
                    id: item.id || 0,
                    key: index,
                    splitAccountA: item.seqNo == null ? '' : item.seqNo,
                    splitAccountE: '',

                };
                return item
            });
            //判断是否存在默认的key
            this.state.data.rulesMemberListList=rulesMemberListList;
            // this.setState({data: {rulesMemberListList:rulesMemberListList});
        }

    }

    postHsbPayChannelConfigAll =() =>{
        post({ url: API_Merchant_findHsbPayChannelConfigAll }).then(res => {
            this.setState({ hsbPayChannelList: res })
        })
    }



    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑支付渠道" });
        postFrom({ url: config.API_hsbPayChannel_getHsbPayChannelConfigClrgRuleById+"?id="+id, data: { } }).then(res => {

            if(res.memberList) {
                res.rulesMemberListList = res.memberList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                    item = {
                        id: item.id || 0,
                        key: index,
                        splitAccountA: item.seqNo == null ? '' : item.seqNo,
                        splitAccountB: '',
                        splitAccountC: '',
                        splitAccountD: '',
                        splitAccountE: item.mktMrchId,
                        splitAccountF: '',
                        splitAccountG: ''
                    };
                    return item
                });
            }

            this.setState({ data:{ ...res, id },selectUpperLimitValue:(res.upperLimit?res.upperLimit==1:false), loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });


    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {

                let { data: { rulesMemberListList } } = this.state;
                this.setState({ loading: true });

                let valueKeys = Object.keys(values);

                let fKeys = valueKeys.filter((item, index) => { //获取出户型字段
                    if (/^splitAccountA[\d]+$/.test(item)) return item;
                });
                values.memberList = fKeys.map((item, index) => { //处理户型字段
                    let id = rulesMemberListList[index].id;
                    let num = item.slice(13);
                    item = {
                        id: id || 0,
                        seqNo: values[`splitAccountA${num}`],
                        mktMrchId: values[`splitAccountE${num}`],
                    };
                    delete values[`splitAccountA${num}`];
                    delete values[`splitAccountB${num}`];
                    delete values[`splitAccountC${num}`];
                    delete values[`splitAccountD${num}`];
                    delete values[`splitAccountE${num}`];
                    delete values[`splitAccountF${num}`];
                    delete values[`splitAccountG${num}`];
                    return item
                });
                values.merchantId= this.state.merchantId;
                console.log(values);
                if(values.startDate){
                    values.startDate = formatTime(values.startDate, "YYYY-MM-DD");
                }
                if(values.endDate){
                    values.endDate = formatTime(values.endDate, "YYYY-MM-DD");
                }
                if(values.collectionEndDate){
                    values.collectionEndDate = formatTime(values.collectionEndDate, "YYYY-MM-DD");
                }

                this.setState({ loading: true });

                if (values.id) {
                    post({ url: config.API_hsbPayChannel_updateHsbPayChannelConfigClrgRule, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_hsbPayChannel_addHsbPayChannelConfigClrgRule, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/HsbPayClrgRule/components/ListAdd/index.js